import { AccountCategory, type HolisticSummaryCategory } from '@fruitful/types';

const FRUITFUL_DEPOSIT_ACCOUNT_DISCLOSURE =
    'Deposit accounts are provided by Emigrant Bank, Member FDIC.';
const FRUITFUL_INVESTMENT_ACCOUNT_DISCLOSURE =
    'Investment accounts are held at Apex Clearing Corp., member FINRA/SIPC.';
export const FRUITFUL_ALL_ACCOUNT_DISCLOSURES = `${FRUITFUL_DEPOSIT_ACCOUNT_DISCLOSURE}\n\n${FRUITFUL_INVESTMENT_ACCOUNT_DISCLOSURE}`;

export const LINKED_ACCOUNT_BALANCE_NOTE =
    'Balances for linked accounts are updated as soon as we receive new data from your institution.';
export const LINKED_ACCOUNT_BALANCE_NOTE_VERBOSE =
    'Balances for linked accounts are updated based on the information we receive from your financial institution. Updates typically occur daily, but timing can vary depending on the institution.';

export const CATEGORY_INFO_MAP: Record<
    HolisticSummaryCategory,
    {
        headerTitle: string;
        infoSheetTitle: string;
        infoSheetDescription: string;
    }
> = {
    [AccountCategory.SPEND]: {
        headerTitle: 'Total Spend Amount',
        infoSheetTitle: 'Spend',
        infoSheetDescription: `Spend should represent your available cash — generally, it would be the total balance of your checking accounts minus the total balance on all your credit cards. \n\n${LINKED_ACCOUNT_BALANCE_NOTE}`,
    },
    [AccountCategory.SAVE]: {
        headerTitle: 'Total Savings',
        infoSheetTitle: 'Save',
        infoSheetDescription: `Save should represent your savings for near-term goals and just-in-case funds — generally, it would be the total balance of all your cash in savings accounts. If any of these accounts hold stocks, bonds, funds, and other securities, the value of the assets can fluctuate as the market does. \n\n${LINKED_ACCOUNT_BALANCE_NOTE}`,
    },
    [AccountCategory.INVEST]: {
        headerTitle: 'Total Invest',
        infoSheetTitle: 'Invest',
        infoSheetDescription: `Invest should represent your investments for long-term goals, such as retirement -- generally, this would include the total balance of all your investment accounts. Because these accounts may hold stocks, bonds, funds, and other securities, the value of the assets can fluctuate as the market does. \n\n${LINKED_ACCOUNT_BALANCE_NOTE}`,
    },
    [AccountCategory.BORROW]: {
        headerTitle: 'Total Borrow',
        infoSheetTitle: 'Borrow',
        infoSheetDescription: `Borrow includes the total outstanding balance of all your loans. \n\n${LINKED_ACCOUNT_BALANCE_NOTE}`,
    },
};

export const categoryInfo = {
    [AccountCategory.SPEND]:
        'For checking and credit card accounts that you spend regularly from.',
    [AccountCategory.SAVE]:
        'For savings accounts that you don’t regularly spend from, like an emergency fund.',
    [AccountCategory.INVEST]: 'For investment and retirement accounts.',
    [AccountCategory.BORROW]: 'For loans, like a mortgage or student loan.',
};
